import { BreadcrumbActionMenuButton } from '@components/breadcrumbs';
import { useModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Menu, MenuItem } from '@mui/material';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { useCurrentWorkspaceId } from '@navigation/WorkspaceContext';
import { navigate } from 'gatsby';
import posthog from 'posthog-js';
import { MouseEvent, useContext, useState } from 'react';
import { GraphsListViewPreviewMenuDownloadConfiguration } from '../GraphsListViewPreviewMenuDownloadConfiguration';
import { GraphsListViewPreviewMenuDuplicateConfiguration } from '../GraphsListViewPreviewMenuDuplicateConfiguration';
import { GraphsListViewPreviewMenuEditConfiguration } from '../GraphsListViewPreviewMenuEditConfiguration';
import { GraphDataContext } from './GraphDataProvider';

export const GraphHeaderDropdown = () => {
  const workspaceId = useCurrentWorkspaceId();
  const { organizationId } = useOrganizationContext();
  const [anchorEl, setAnchorEl] = useState<HTMLElement>();
  const open = Boolean(anchorEl);
  const { graphMetadata, graphMetadataLoading, refetchGraphMetadata } =
    useContext(GraphDataContext);

  const handleClick = (event: MouseEvent) => setAnchorEl(event.currentTarget as HTMLElement);
  const handleClose = () => setAnchorEl(null);

  const { showModal: showEditModal } = useModal({
    component: GraphsListViewPreviewMenuEditConfiguration,
    componentProps: { ...graphMetadata, refetch: refetchGraphMetadata },
    modalProps: { title: `Edit ${graphMetadata?.name}` },
  });

  const onDuplicate = (newGraphId?: string) => {
    if (newGraphId) {
      void navigate(`/${organizationId}/workspaces/${workspaceId}/graphs/`);
    } else {
      refetchGraphMetadata();
    }
  };

  const { showModal: showDuplicateModal } = useModal({
    component: GraphsListViewPreviewMenuDuplicateConfiguration,
    componentProps: { ...graphMetadata, refetch: onDuplicate },
    modalProps: { title: `Save ${graphMetadata?.name || 'graph'} copy as` },
  });

  const { showModal: showDownloadModal } = useModal({
    component: GraphsListViewPreviewMenuDownloadConfiguration,
    componentProps: { ...graphMetadata },
    modalProps: { title: `Download ${graphMetadata?.name}` },
  });

  const handleEditClick = () => {
    showEditModal();
    handleClose();
  };
  const handleDuplicateClick = () => {
    posthog.capture('user_copy-graph_intent');
    showDuplicateModal();
    handleClose();
  };
  const handleDownloadClick = () => {
    showDownloadModal();
    handleClose();
  };

  if (graphMetadataLoading) {
    return null;
  }

  return (
    <>
      <BreadcrumbActionMenuButton onClick={handleClick} />
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { mt: 3 } } }}
      >
        <MenuItem onClick={handleEditClick}>
          <Typography>Edit</Typography>
        </MenuItem>
        <MenuItem onClick={handleDuplicateClick}>
          <Typography>Save As</Typography>
        </MenuItem>
        <MenuItem onClick={handleDownloadClick}>
          <Typography>Download</Typography>
        </MenuItem>
      </Menu>
    </>
  );
};
